/**
 * Application version utility
 * Centralized version management for the application
 */

export const APP_VERSION = 'V1.7.0'

export const getVersionText = () => {
  return `AI Driven Document Classification : ${APP_VERSION}`
}

export const getVersion = () => {
  return APP_VERSION
}
